import { Lab } from "../../../backend/src/types";
import { ENDPOINT } from "../endpoint/endpoint";
import { errorMessage } from "../function/errorMessage";

type ApiResponse<T> = { data: T; error: string | null };

// 研究室リストを取得
export async function getLabList(tenant_id: number) {
  try {
    const res = await fetch(ENDPOINT.lab.getLabList, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ tenant_id }),
    });

    const { data, error }: ApiResponse<Lab[]> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("研究室リストの取得に失敗しました。", error);
    return [];
  }
}

// 研究室を新規作成
export async function addLab(lab: Lab) {
  try {
    const res = await fetch(ENDPOINT.lab.addLab, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ lab }),
    });

    const { data, error }: ApiResponse<Lab> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("研究室の登録に失敗しました。", error);
    return null;
  }
}

// 研究室情報を更新
export async function updateLab(lab: Lab) {
  try {
    const res = await fetch(ENDPOINT.lab.updateLab, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ lab }),
    });

    const { data, error }: ApiResponse<Lab> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("研究室情報の更新に失敗しました。", error);
    return null;
  }
}

// 研究室を削除
export async function deleteLab(lab_id: number): Promise<boolean> {
  try {
    const res = await fetch(ENDPOINT.lab.deleteLab, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ lab_id }),
    });

    if(res.status === 204) {
      return true;
    }

    const { error }: ApiResponse<null> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }
    return true;
  } catch (error) {
    errorMessage("研究室の削除に失敗しました。", error);
    return false;
  }
}
